import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'd3';
import { FaStar, FaChevronLeft } from 'react-icons/fa';
import { FaStar as FaRegStar } from 'react-icons/fa';
import './Metadata.scss';

function Metadata(props) {
  const { name, population, confidence, analysisPeriod, selectedArea, updateSelectedArea, analysisCondition, } = props;

  const popTotal = (population || []).filter(d => (!selectedArea && d.aag_id === 0) || d.aar_id === selectedArea)

    .map((d) => {
      const { phase3, phase4, phase5, phase6} = d;
      let t = 0;
      if (phase3) t += phase3.population;
      if (phase4) t += phase4.population;
      if (phase5) t += phase5.population;
      if (phase6) t = phase6.population;
      return t;
    })
    .reduce((sum, pop) => sum + pop, 0);

  const formattedPop = format('.3~s')(popTotal);

  const projected = analysisPeriod !== 'C';
  const curProjPrefix = analysisPeriod === 'A' ? '2nd Projected': ( analysisPeriod ==='P' ? 'Projected' : 'Current');
  const crisisText= analysisCondition === 'C' ? 'people Level 3 and higher' : 'people in crisis or worse';

  return (
    <div className={`metadata${projected ? ' metadata--projected' : ''}`}>
      <div className="metadata__main">
        <div className={`metadata__name ${analysisCondition === 'C' ? 'metadata__name--chronic' : ''}`}>{name}</div>
        <div className={`metadata__population ${analysisCondition === 'C' ? 'metadata__population--chronic' : ''}`}>
          {curProjPrefix}: &nbsp;<span>{formattedPop }</span>{crisisText}
        </div>
      </div>
      <div className="metadata__bottom">
        <div className="metadata__confidence">
          <span>Evidence Level of Analysis:</span>
          {confidence >= 1 ? <FaStar /> : <FaRegStar />}
          {confidence >= 2 ? <FaStar /> : <FaRegStar />}
          {confidence > 2 ? <FaStar /> : <FaRegStar />}
        </div>
        {selectedArea && (
          <div className="metadata__reset" onClick={() => { updateSelectedArea(null); }}>
            <FaChevronLeft />
            Return to Country
          </div>
        )}
      </div>
    </div>
  );
}

Metadata.defaultProps = {
  name: '',
  population: [],
  confidence: 0,
  analysisPeriod: 'C',
  analysisCondition: '',
  selectedArea: null,
  updateSelectedArea: () => {},
};

Metadata.propTypes = {
  name: PropTypes.string,
  population: PropTypes.arrayOf(PropTypes.object),
  confidence: PropTypes.number,
  analysisPeriod: PropTypes.string,
  analysisCondition: PropTypes.string,
  selectedArea: PropTypes.string,
  updateSelectedArea: PropTypes.func,
};

export default Metadata;
